import React, { useEffect, useState } from "react";
import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import TextField from "common/TextField";
import { useTranslation } from "react-i18next";
const Step1 = ({
  formik,
  bGId,
  bankList = [],
  handleNext,
  handleError,
  handleCompletion,
}) => {
  const { t } = useTranslation();
  const STEP_ID = 1;
  const { location, branchName, bankId, bankGroupId } = formik.values;
  let [disabled, setDisabled] = useState(() =>
    location.length > 0 &&
      branchName.length > 0 &&
      bankId.length > 10 &&
      bankGroupId.length > 10
      ? false
      : true
  );

  useEffect(() => {
    setDisabled(
      location.length > 0 &&
        branchName.length > 0 &&
        bankId.length > 10 &&
        bankGroupId.length > 10
        ? false
        : true
    );
  }, [location, branchName, bankId, bankGroupId]);

  useEffect(() => {
    if (!disabled) {
      handleError(STEP_ID, false);
      handleCompletion(STEP_ID, true);
    } else if (disabled) {
      handleError(STEP_ID, true);
      handleCompletion(STEP_ID, false);
    }
  }, [disabled]);
  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <h6>{t("bank-information")}</h6>
      <div className=" mt-2">
        <SearchableSelect
          placeholder="Select Bank Group"
          name="bankGroupId"
          handleChange={(key, value) => formik.setFieldValue(key, value)}
          value={formik.values.bankGroupId}
          options={[{ value: bGId, label: "Genossenschaftsbanken" }]}
          errors={
            formik.values.bankGroupId.length > 10 && formik.errors.bankGroupId
          }
          isDisabled={true}
          defaultValue={bankGroupId}
        />
      </div>
      <div className=" mt-2">
        <SearchableSelect
          placeholder={t("select-bank")}
          name="bankId"
          handleChange={(key, value) => formik.setFieldValue(key, value)}
          value={formik.values.bankId}
          options={bankList?.map((el) => {
            return { value: el.bankId, label: el.bankName };
          })}
          errors={formik.values.bankId.length > 10 && formik.errors.bankId}
          isDisabled={true}
          defaultValue={bankId}
        />
      </div>
      <h6 className="mt-2">{t("branch-information")}</h6>
      <div className="inputField mt-2">
        <TextField
          isDisabled={true}
          type="text"
          className="form-control"
          placeholder={t("branch-name")}
          name="branchName"
          onChange={formik.handleChange}
          value={formik.values.branchName}
          error={formik.touched.branchName && formik.errors.branchName}
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder="Location"
          name="location"
          onChange={formik.handleChange}
          value={formik.values.location}
          error={formik.touched.location && formik.errors.location}
          isDisabled={true}
        />
      </div>
      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn "
          onClick={handleNext}
          style={{
            padding: "10px 35px",
            ...(disabled && { filter: "  opacity(30%)" }),
          }}
          disabled={disabled}
        >
          {t("next")}
        </button>
      </div>
    </div>
  );
};

export default Step1;
